// Single source of truth for App Store / Play Store URLs.
export const APP_STORE_URL =
  "https://apps.apple.com/de/app/piefolio-ai-wealth-tracker/id6759684076";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=ai.piefolio.portfolio";
export const SITE_URL = "https://getpiefolio.com";

/**
 * App Store Connect provider token (App Analytics → Campaigns → "Generate a campaign link").
 * Public, account-wide; Apple only attributes installs to `ct` when `pt` is present.
 */
export const APPLE_PROVIDER_TOKEN = "128589696";

/**
 * Adds install attribution per campaign (e.g. "home_clarity" / "lp_maison"):
 * - Google Play: utm_* (Play Console acquisition reports) plus the same values in
 *   `referrer` (Install Referrer API in the app).
 * - App Store: `ct` campaign token (+ `pt` provider token) for App Store Connect.
 */
export const withUtm = (url: string, location: string, campaign?: string) => {
  if (!campaign) return url;
  try {
    const u = new URL(url);
    const utm = { utm_source: location || "website", utm_medium: "web", utm_campaign: campaign };
    if (u.hostname === "apps.apple.com") {
      if (APPLE_PROVIDER_TOKEN) u.searchParams.set("pt", APPLE_PROVIDER_TOKEN);
      u.searchParams.set("ct", campaign.slice(0, 100));
      u.searchParams.set("mt", "8");
    } else {
      for (const [key, value] of Object.entries(utm)) u.searchParams.set(key, value);
      u.searchParams.set("referrer", new URLSearchParams(utm).toString());
    }
    return u.toString();
  } catch {
    return url;
  }
};

/** Campaigns with their own "Scan to install" QR code (src/assets/appstore-qr-<campaign>.svg). */
export const QR_CAMPAIGNS = ["home_clarity", "lp_maison"] as const;
export type QrCampaign = (typeof QR_CAMPAIGNS)[number];
